import errorParser from '../../utils/errorParser'
import RestResourceService from "@/services/RestResourceService";

function initialState() {
    return {
        data: '',
        headers: {},
        mapping: []
    }
}

export default {
    state: initialState(),
    getters: {
        WEBPAGE_ANALYZER_DATA: state => {
            return state.data
        },
        WEBPAGE_ANALYZER_HEADERS: state => {
            return state.headers
        },
        WEBPAGE_ANALYZER_MAPPING: state => {
            return state.mapping
        }
    },
    mutations: {
        SET_WEBPAGE_ANALYZER_DATA(state, payload) {
            state.data = payload;
        },
        SET_WEBPAGE_ANALYZER_HEADERS(state, payload) {
            state.headers = payload;
        },
        ADD_WEBPAGE_ANALYZER_MAPPING(state, payload) {
            state.mapping.push(payload);
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
        RESET_MAPPING(state) {
            state.mapping = [];
        }
    },
    actions: {
        GET_WEBPAGE_ANALYZER_DATA: async (context, payload) => {
            return RestResourceService.getResources(`jsoup-analyzer/analyze?url=${payload.form.url}`)
                .then((response) => {
                    context.commit('SET_WEBPAGE_ANALYZER_DATA', response.data);
                })
                .catch((error) => {
                    errorParser.parse(error);
                    throw new Error(error);
                })
        },
        UPDATE_WEBPAGE_ANALYZER_HEADERS: (context, payload) => {
            context.commit('SET_WEBPAGE_ANALYZER_HEADERS', payload);
        },
        UPDATE_WEBPAGE_ANALYZER_MAPPING: (context, payload) => {
            context.commit('ADD_WEBPAGE_ANALYZER_MAPPING', payload);
        },
        RESET: (context, payload) => {
            context.commit('RESET', payload);
        },
        RESET_MAPPING: (context) => {
            context.commit('RESET_MAPPING');
        },
    }
}
